import { computed, inject, Injector, signal } from "@angular/core";
import { CommonForm, CommonOptionsFieldConfig, CommonSelectField } from "@eforall/common";
import { LanguageId } from "@interfaces";
import { AccApplicationDialogDataService } from "../../acc-application-dialog-data.service";
import { AppService } from "../../../../../services";


export class ChangeLanguageFormService {

	public readonly form = new CommonForm<{ languageId: number }>(inject(Injector));
	public accAppDialogDataService = inject(AccApplicationDialogDataService);
	private app = inject(AppService);

	public readonly canManageApplication = computed(() => {
		const permissions = this.app.data().permissions;
		return permissions.isSoftwareDev || permissions.canManageAdmissionsStaff;
	});
	private readonly currentLanguageId = computed(() => this.accAppDialogDataService.dialogData()?.details.languageId);

	private readonly languageOptions = computed(() => [
		{
			text: 'English',
			value: LanguageId.English,
			disabled: false,
		},
		{
			text: 'Spanish',
			value: LanguageId.Espanol,
			disabled: false,
		}
	]);

	public readonly languageId = computed<CommonSelectField<number>>(() => ({
		config: signal<CommonOptionsFieldConfig<number>>({
			label: 'Application Language',
			options: this.languageOptions(),
			isRequired: true,
			isSpanish: false,
			isEnabled: computed(() => this.canManageApplication()),
		}),
		actualValue: computed(() => this.currentLanguageId() || LanguageId.English),
		pendingValue: signal<number | null>(null),
		saving: signal(false),
		error: signal(''),
		formFieldName: 'languageId',
		form: this.form,
	}));

	/**
	 * Determines if the save button should be disabled.
	 * The button is disabled if readonly mode is active or if the language hasn't changed.
	 */
	public disableSaveBtn = computed(() => {
		if (!this.canManageApplication()) return true;

		const currentLangId = this.currentLanguageId();
		const selectedLangId = this.languageId().pendingValue() || this.languageId().actualValue();

		// Disable if no change has been made
		if (currentLangId === selectedLangId) return true;

		return false;
	});
}
